import React, { useEffect, useRef, useState } from 'react';
import './css/index.scss';
import InputMask from 'react-input-mask';
import SearchIcon from '../../assets/formIcons/search.svg';
import SearchBlueIcon from '../../assets/formIcons/searchBlue.svg';
import CloseIcon from '../../assets/formIcons/close.svg';
import MyLoading from '../MyLoading';

function SearchInput({
  value,
  onChange,
  className = '',
  wrapperClassName = '',
  error,
  withLeftIcon = true,
  withCloseIcon = true,
  shouldValueConsiderAsFocus = true,
  labelText,
  disabled,
  isLarge,
  isTimeInput = false,
  functionAtCleaning,

  withDropdown,
  dropdownItems,
  dropdownLabelField,
  dropdownKeyField,
  onDropdownItemPress,
  dropdownLoading,
  mask,

  ...p
}) {
  const inputRef = useRef();
  const [isFocused, setIsFocused] = useState(false);
  const [isFocusedDelay, setIsFocusedDelay] = useState(false);

  const onWrapperClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
      setIsFocused(true);
    }
  };

  const onClearClick = (ev) => {
    ev.stopPropagation();
    if (functionAtCleaning) {
      functionAtCleaning(ev);
    } else {
      onChange('', true);
    }
    if (inputRef.current) {
      inputRef.current.blur();
    }
  };
  const handleTimeInput = (e) => {
    const input = e.target.value.replace(/[^\d:]/g, '');
    let formattedInput = input;

    if (input.length > 2 && !input.includes(':')) {
      formattedInput = `${input.slice(0, 2)}:${input.slice(2)}`;
    }

    if (formattedInput.length > 5) {
      formattedInput = formattedInput.slice(0, 5);
    }

    onChange(formattedInput);
  };

  const handleInputChange = (e) => {
    if (isTimeInput) {
      handleTimeInput(e);
    } else {
      onChange(e);
    }
  };

  useEffect(() => {
    if (isFocused) {
      setIsFocusedDelay(true);
    } else {
      setTimeout(() => {
        setIsFocusedDelay(false);
      }, 300);
    }
  }, [isFocused]);

  return (
    <div
      className={`search_input_wrapper ${(isFocused || (value && shouldValueConsiderAsFocus)) ? 'search_input_wrapper_focused' : ''} ${disabled && 'disabled'} ${error && 'error'} ${wrapperClassName}`}
      onClick={onWrapperClick}
    >
      <div className="search_input_left">
        {withLeftIcon && (
        <div className="search_input_search">
          <img src={isFocused ? SearchBlueIcon : SearchIcon} alt="" />
        </div>
        )}
        {isLarge ? (
          <textarea
            ref={inputRef}
            className={`search_input is_textarea ${!withLeftIcon && 'with_padding'} ${className}`}
            disabled={disabled}
            value={value}
            onChange={handleInputChange}
            onBlur={() => setIsFocused(false)}
            {...p}
          />
        ) : mask ? (
          <InputMask
            inputRef={inputRef}
            mask={mask}
            className={`search_input ${!withLeftIcon && 'with_padding'} ${className}`}
            disabled={disabled}
            value={value}
            onChange={handleInputChange}
            onBlur={() => setIsFocused(false)}
            maxLength={isTimeInput ? 5 : undefined}
            placeholder={isTimeInput ? 'HH:MM' : p.placeholder}
            autoComplete="off"
            {...p}
          />
        ) : (
          <input
            ref={inputRef}
            className={`search_input ${!withLeftIcon && 'with_padding'} ${className}`}
            disabled={disabled}
            value={value}
            onChange={handleInputChange}
            onBlur={() => setIsFocused(false)}
            maxLength={isTimeInput ? 5 : undefined}
            placeholder={isTimeInput ? 'HH:MM' : p.placeholder}
            {...p}
          />
        )}
      </div>

      {withCloseIcon && (
        <div
          onClick={onClearClick}
          className={`search_input_close ${(isFocused || value) ? 'search_input_close_visible' : ''}`}
        >
          <img src={CloseIcon} alt="" />
        </div>
      )}
      <p className="error_text">{error}</p>
      {labelText && <small className="input_small">{labelText}</small>}

      {withDropdown && isFocusedDelay && (
      <div className="search_input_dropdown">
        {dropdownLoading ? (
          <MyLoading className="search_input_dropdownLoading" />
        ) : !dropdownItems?.length ? (
          <p className="search_input_dropdownEmptyText">Не найдено.</p>
        ) : (
          <div>
            {dropdownItems.map((item) => (
              <div
                key={item[dropdownKeyField]}
                className="search_input_dropdownItem"
                onClick={() => onDropdownItemPress(item)}
              >
                <p className="search_input_dropdownItemText">
                  {item[dropdownLabelField]}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
      )}
    </div>
  );
}

export default SearchInput;
